import { Grid, MenuItem, Select } from '@yuno/design-system-web'
import { InputLabelStyled } from '../connection-form/styles'
import { useFormContext } from 'react-hook-form'
import { sortFunction } from '../../utils/sortObj'
import { useTranslation } from 'react-i18next'

export const ConnectionIntegrationType = ({
  hasSelectFocus,
  renderIntegrationType,
  connectionResponse,
  handleFocus,
  handleChangeIntegration,
  integrationTypes,
  renderPaymentMethodType,
  handleChangePayment,
  formData,
  paymentMethods,
}) => {
  const {
    register,
    getValues,
    formState: { errors },
  } = useFormContext()
  const { t } = useTranslation()

  return (
    <>
      <Grid item xs={12} sx={{ paddingTop: '20px' }}>
        <InputLabelStyled
          focused={hasSelectFocus.integrationType}
          id="integration_type"
        >
          {t('integrationType')}
        </InputLabelStyled>
        <Select
          labelId="integration_type"
          id="integration_type"
          name="integration_type"
          defaultValue={getValues('integration_type')}
          fullWidth
          variant="outlined"
          displayEmpty
          MenuProps={{ id: 'integration_type-menu' }}
          error={!!errors['integration_type']}
          renderValue={renderIntegrationType}
          {...register('integration_type' as never, {
            required: true,
            disabled: !!connectionResponse,
          })}
          onBlur={handleFocus.bind(null, 'integrationType', false)}
          onFocus={handleFocus.bind(null, 'integrationType', true)}
          onChange={handleChangeIntegration.bind(this)}
        >
          {!!integrationTypes &&
            integrationTypes
              ?.sort((a, b) => sortFunction(a, b))
              .map((integration) => {
                return (
                  <MenuItem key={integration.id} value={integration}>
                    {integration.name}
                  </MenuItem>
                )
              })}
        </Select>
      </Grid>
      <Grid item xs={12} sx={{ paddingTop: '20px' }}>
        <InputLabelStyled
          focused={hasSelectFocus.paymentMethod}
          id="payment_method_type"
        >
          {t('paymenthMethod')}
        </InputLabelStyled>
        <Select
          labelId="payment_method_type"
          id="payment_method_type"
          name="payment_method_type"
          defaultValue={formData['payment_method_type']}
          fullWidth
          variant="outlined"
          displayEmpty
          MenuProps={{ id: 'payment_method_type-menu' }}
          error={!!errors['payment_method_type']}
          renderValue={() =>
            renderPaymentMethodType(getValues('payment_method_type'))
          }
          {...register('payment_method_type' as never, {
            required: true,
          })}
          onBlur={handleFocus.bind(null, 'paymentMethod', false)}
          onFocus={handleFocus.bind(null, 'paymentMethod', true)}
          onChange={handleChangePayment.bind(this)}
          disabled
        >
          {paymentMethods?.map((item) => (
            <MenuItem key={item.type} value={item.type}>
              {item.description || item.name}
            </MenuItem>
          ))}
        </Select>
      </Grid>
    </>
  )
}
